<div class="dropdown-link-wrap" (click)="toggleDropdown()">
  <ng-content></ng-content>
</div>
